import { combineReducers } from "redux";
import loginReducer from './Reducers/LoginReducer'
import { profileReducer } from "./Reducers/ProfileReducer";
import { notificationReducer } from "./Reducers/NotificationReducer";
export const mainReducer = combineReducers({
  login: loginReducer,
  profile:profileReducer,
  notify:notificationReducer
});
